module.exports = __webpack_public_path__ + "static/media/login_banner.550d7505.png";